import { Subject } from 'rxjs';

export interface ISDialogHost {
  onMinimize(): void;
  reopenDialog(): void;
  maximizeDialog(): void;
  closeDialog(): void;
}

export class DialogRef<T = any> {
  private readonly _afterClosed = new Subject<T | null>();
  readonly afterClosed = this._afterClosed.asObservable();

  private _host: ISDialogHost | null = null;

  _attach(host: ISDialogHost) {
    this._host = host;
  }

  minimize() { this._host?.onMinimize(); }
  restore() { this._host?.reopenDialog(); }
  toggleMaximize() { this._host?.maximizeDialog(); }

  /** fecha e notifica */
  close(result: T | null = null) {
    this._afterClosed.next(result);
    this._afterClosed.complete();
  }
}
